/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {ID} from '../../../../../../_metronic/helpers'

type Props = {
  project_name: string
  project_id: ID
  clientName: string
  clientId: ID
  rowIndex: number
  columnId: number
}

const TaskByUserProjectCell: FC<Props> = ({
  project_name,
  project_id,
  clientName,
  clientId,
  rowIndex,
  columnId,
}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column task-project-cell'>
        <Link to={`/projects/${project_id}`} title={project_name}>
          <span className='text-gray-800 text-hover-primary text-truncate d-block'>
            {project_name}
          </span>
        </Link>

        <Link to={`/clients/${clientId}`}>
          <span className='text-muted text-hover-primary fs-8 text-truncate d-block'>
            {clientName}
          </span>
        </Link>
      </div>
    </div>
  )
}

export {TaskByUserProjectCell}
